module.exports = __webpack_public_path__ + "img/512426799.db2f12b6.jpg";